import { useContext } from "react";
import { Button } from "flowbite-react";
import AppContext from "../context/AppContext";

const Page = ({ state, dispatch }) => {
  const {
    brand: {
      buttonPrimaryBorderColor,
      buttonPrimaryBackgroundColor,
      buttonPrimaryTextColor,
    },
  } = useContext(AppContext);

  return (
    <>
      <h2 className="text-4xl font-bold text-center">
        Your session has timed out
      </h2>

      <p className="text-center mt-4 mb-16">
        Please reload this page to restart your booking
      </p>

      <div className="flex gap-16 justify-center">
        <div className="w-48">
          <Button
            type="submit"
            color="dark"
            className="w-full"
            style={{
              borderColor: buttonPrimaryBorderColor,
              backgroundColor: buttonPrimaryBackgroundColor,
              color: buttonPrimaryTextColor,
            }}
            onClick={() => window.location.reload()}
          >
            Restart booking
          </Button>
        </div>
      </div>
    </>
  );
};

const Description = ({ state }) => <></>;

const tuple = { Page, Description };

export default tuple;
